export const adminStackLinking = {
    screens: {
        Admin_Home: {
            path: 'admin/home',
        },
        Admin_Notes: {
            path: 'admin/notes',
        },
    },
};
export const adminTabsLinking = {
    screens: {
        Admin_Home: {
            path: 'admin/*',
        },
    },
};
